import { render, staticRenderFns } from "./DeMainContainer.vue?vue&type=template&id=3c56fa40&scoped=true"
import script from "./DeMainContainer.vue?vue&type=script&lang=js"
export * from "./DeMainContainer.vue?vue&type=script&lang=js"
import style0 from "./DeMainContainer.vue?vue&type=style&index=0&id=3c56fa40&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c56fa40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c56fa40')) {
      api.createRecord('3c56fa40', component.options)
    } else {
      api.reload('3c56fa40', component.options)
    }
    module.hot.accept("./DeMainContainer.vue?vue&type=template&id=3c56fa40&scoped=true", function () {
      api.rerender('3c56fa40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dataease/DeMainContainer.vue"
export default component.exports